import { POST_TYPE_POST, POST_TYPE_TICKER } from '../Post.constants'

export function getPostTypeSelectOptions(t) {
  return [
    { label: t('Newsboard.PostTypeLabel'), value: POST_TYPE_POST },
    { label: t('Newsboard.PostTypeTickerLabel'), value: POST_TYPE_TICKER },
  ]
}
